import React from 'react';
import { FadeIn } from './FadeIn';
const steps = [{
  day: 'Día 1-3',
  title: 'La Calma Inmediata',
  description: 'Implementas la técnica de lavado suave. La picazón se reduce un 60% en las primeras 48 horas. Sientes frescura por primera vez en meses.'
}, {
  day: 'Día 4-7',
  title: 'Restauración de Barrera',
  description: 'La descamación empieza a ceder. Tu cuero cabelludo deja de sentirse tirante. Aprendes a identificar qué ingredientes te dañan.'
}, {
  day: 'Día 8-14',
  title: 'Mantenimiento y Equilibrio',
  description: 'Tu piel recupera su color natural. El exceso de grasa o sequedad se normaliza. Tienes una rutina clara para mantener este estado para siempre.'
}];
export function TimelineSection() {
  return <section className="py-24 bg-white" data-id="element-172">
      <div className="max-w-4xl mx-auto px-4" data-id="element-173">
        <FadeIn className="text-center mb-16" data-id="element-174">
          <h2 className="font-serif text-3xl md:text-4xl text-warm-900 mb-4" data-id="element-175">
            Tu viaje de 14 días
          </h2>
          <p className="text-warm-600" data-id="element-176">
            Un proceso paso a paso, diseñado para no abrumarte.
          </p>
        </FadeIn>

        <div className="relative" data-id="element-177">
          {/* Vertical Line */}
          <div className="absolute left-[19px] md:left-1/2 top-0 bottom-0 w-0.5 bg-sage-100 -ml-px md:transform md:-translate-x-1/2" data-id="element-178" />

          <div className="space-y-12" data-id="element-179">
            {steps.map((step, index) => <FadeIn key={index} delay={index * 0.2} className={`relative flex items-start md:items-center ${index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'}`} data-id="element-180">
                {/* Dot */}
                <div className="absolute left-0 md:left-1/2 w-10 h-10 bg-white border-4 border-sage-200 rounded-full z-10 flex items-center justify-center md:transform md:-translate-x-1/2" data-id="element-181">
                  <div className="w-3 h-3 bg-sage-500 rounded-full" data-id="element-182" />
                </div>

                {/* Content Spacer for Desktop */}
                <div className="hidden md:block w-1/2" data-id="element-183" />

                {/* Content Box */}
                <div className={`ml-16 md:ml-0 md:w-1/2 ${index % 2 === 0 ? 'md:pr-16 md:text-right' : 'md:pl-16 md:text-left'}`} data-id="element-184">
                  <span className="inline-block py-1 px-3 bg-sage-50 text-sage-700 text-sm font-semibold rounded-full mb-2" data-id="element-185">
                    {step.day}
                  </span>
                  <h3 className="font-serif text-2xl text-warm-900 mb-2" data-id="element-186">
                    {step.title}
                  </h3>
                  <p className="text-warm-600 leading-relaxed" data-id="element-187">
                    {step.description}
                  </p>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}